var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7909",
    x: 0,
    y: 0,
    width: 59,
    height: 59,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27937",
    "data-name": "Group 27937",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_7909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7909-2",
    "data-name": "Rectangle 7909",
    width: 41,
    height: 41,
    rx: 7,
    transform: "translate(9 6)",
    fill: "#7fb1da"
  })), /*#__PURE__*/React.createElement("g", {
    id: "visibility_black_24dp",
    transform: "translate(7.054 7.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16651",
    "data-name": "Path 16651",
    d: "M0,0H27.067V27.067H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16652",
    "data-name": "Path 16652",
    d: "M13.406,6.256a11.019,11.019,0,0,1,9.947,6.2,11.077,11.077,0,0,1-19.894,0,11.019,11.019,0,0,1,9.947-6.2m0-2.256A13.338,13.338,0,0,0,1,12.459a13.327,13.327,0,0,0,24.812,0A13.338,13.338,0,0,0,13.406,4Zm0,5.639a2.82,2.82,0,1,1-2.82,2.82,2.821,2.821,0,0,1,2.82-2.82m0-2.256a5.075,5.075,0,1,0,5.075,5.075A5.083,5.083,0,0,0,13.406,7.383Z",
    transform: "translate(0.128 0.511)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSelected);
export default __webpack_public_path__ + "static/media/viewSelected.d97fe3bc3fd49e7bef064ddea4510e84.svg";
export { ForwardRef as ReactComponent };